<!-- 财务状况与音像制品出版汇总表 -->

<template>
  <div class="tabCage table5E">
    <div class="tabTtl">
      <span>表 1-5：获得表彰情况登记表</span>
    </div>
    <!-- <div class="tip-div">
      <span class="tip-red"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
    </div> -->

    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">奖项名称：</td>
            <td class="edInpBig">
              <el-form-item prop="hjName" :inline-message="true">
                <el-input v-model="params.hjName" size="small" placeholder="请输入奖项名称"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">表彰对象：</td>
            <td class="edInp">
              <el-form-item prop="bzObject" :inline-message="true">
                <el-select v-model="params.bzObject" size="small" placeholder="请选择表彰对象">
                  <el-option v-for="item in dicDats['C023']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">奖励内容：</td>
            <td class="edInpTextArea">
              <el-form-item prop="commend" :inline-message="true">
                <el-input
                  :rows="3"
                  type="textarea"
                  v-model="params.commend"
                  size="small"
                  placeholder="请输入奖励内容"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">颁奖单位：</td>
            <td class="edInp">
              <el-form-item prop="bjName" :inline-message="true">
                <el-input v-model="params.bjName" size="small" placeholder="请输入颁奖单位"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">获奖级别：</td>
            <td class="edInp edSelect">
              <el-form-item prop="hjLevel" :inline-message="true">
                <el-select v-model="params.hjLevel" size="small" placeholder="请选择获奖级别">
                  <el-option v-for="item in dicDats['C024']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="dicMap['C024'][params.hjLevel] == '其他'" prop="hjLevelOther" :inline-message="true">
                <el-input v-model="params.hjLevelOther" size="small" placeholder="请输入获奖级别"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">表彰时间：</td>
            <td class="edInpTime">
              <el-form-item prop="hjDate" :inline-message="true">
                <TimeSelect style="display: inline-block" :outTime="htTime" @time-frash="timeUpdate" />
              </el-form-item>
            </td>
          </tr>
        </table>
      </div>
    </el-form>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="pubStatus == 0" type="primary" @click="editSave('paramCk')" size="small">保存</el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt5";
import { tabUpdate5, tabRead5 } from "@/api/pressRole/pressRole";
import TimeSelect from "@/views/components/date/date";
export default {
  components: {
    TimeSelect,
  },
  data() {
    return {
      params: bsParams,
      rules: paramsRule,
      dicDats: {},
      submiting: false,
      htTime: "",

      dicMap: {},
      pubStatus: 0,
      // 日期格式
    };
  },
  methods: {
    editSave: function (name) {
      let that = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.params.publishId = this.$route.query.pressId;
          this.params.publishMaterialId = this.$route.query.mtId;

          tabUpdate5({
            // pcommend: this.params,
            // 模组化
            data: this.params,
            // 身份验证要用
            publishMaterialId: this.params.publishMaterialId,
          })
            .then((response) => {
              let tipCode = response.payload.pcommend.code;
              let tipMessage = response.payload.pcommend.message;

              that.submiting = false;
              if (tipCode == -1) {
                that.$message.error(`保存错误: ${tipMessage}`);
                return;
              }
              this.$message({
                message: "保存成功！",
                type: "success",
              });
              // this.params.isIndependentLP = 1;
              this.goBack();
            })
            .catch((error) => {
              this.submiting = false;
            });
        } else {
          return false;
        }
      });
    },

    dictInit: function () {
      let nameArr = ["C023", "C024"];
      let newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr",
      });
      newPromise.then((result) => {
        this.dicDats = result;
        this.dicMap["C024"] = this.$store.getters.dictionary["C024"];
      });
    },

    tabReEdit: function () {
      tabRead5({
        id: this.$route.query.id,
      }).then((response) => {
        this.params = response.pcommend;
        this.htTime = this.params.hjDate;
      });
    },

    inpDisableCtrls: function (val) {
      if (this.params.isIndependentLP == 1) {
        this.inpDisable = false;
      } else if (this.params.isIndependentLP == 2) {
        this.inpDisable = true;
      }
    },

    changeHandle: function () {
      let newDate = new Date().getTime();
      if (new Date(this.params.hjDate).getTime() > newDate) {
        this.params.hjDate = "";
        this.$message.error("表彰时间不可大于当前日期！");
      }
    },

    timeUpdate: function (dat) {
      this.params.hjDate = dat;
      // // console.log(dat);
      // console.log()
    },

    goBack: function () {
      this.$router.go(-1);
    },
  },

  created: function () {
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  },

  beforeDestroy: function () {
    for (let key in this.params) {
      this.params[key] = "";
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table5E .edInp .el-textarea {
  width: 450px;
  vertical-align: middle;
}

.table5E .timeArea .el-input {
  width: 148px !important;
}

.table5E .edSelect .el-form-item {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// table5.vue?661f4644